import { Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledReleaseDate = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(12),
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
}));
